(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["_", "jQuery"], factory);
	else if(typeof exports === 'object')
		exports["LicenseSelector"] = factory(require("_"), require("jQuery"));
	else
		root["LicenseSelector"] = factory(root["_"], root["jQuery"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__185__, __WEBPACK_EXTERNAL_MODULE__786__) => {
return 